<script setup lang="ts">
import { computed } from "vue";
import { t } from "../i18n";
const props = defineProps<{ status: string; label?: string }>();
const text = computed(() => {
  if (props.label) return props.label;
  const key = `conversation.status.${props.status}`;
  return t(key as never);
});
</script>
<template>
  <span class="status-chip" :class="status">{{ text }}</span>
</template>
